import React from 'react';
import AddressSuggestInput from './AddressSuggestInput';
import ActivityTypeSelect from './ActivityTypeSelect';
import TravelRoutingEditor from './TravelRoutingEditor';

export default function ActivityModal({
  draft,
  setDraft,
  date,
  activityCategories,
  activityTypes,
  refetchTypes,
  openNativePicker,
  cityKeyFromText,
  onSubmit,
  onCancel,
}) {
  const isEditing = !!draft.activity_id;
  const catId = String(draft.category_id || '');
  const cat = catId
    ? (Array.isArray(activityCategories) ? activityCategories : []).find(c => String(c.category_id) === catId)
    : null;
  const isTravel = ((cat?.category_name || '').toLowerCase() === 'travel');
  const endDateValue = String(draft.end_date || date).slice(0, 10);

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <div className="tp-field">
        <span className="tp-label">Title</span>
        <input
          type="text"
          placeholder="Title"
          value={draft.title || ''}
          onChange={e => setDraft(prev => ({ ...prev, title: e.target.value }))}
        />
      </div>

      <ActivityTypeSelect
        categories={activityCategories}
        types={activityTypes}
        categoryId={draft.category_id}
        typeId={draft.type_id}
        onCategoryChange={v => setDraft(prev => ({ ...prev, category_id: v, type_id: '' }))}
        onTypeChange={v => setDraft(prev => ({ ...prev, type_id: v }))}
        onTypeCreated={newType => {
          refetchTypes();
          setDraft(prev => ({ ...prev, type_id: newType.type_id }));
        }}
        placeholderCategory="Select Category"
        placeholderType="Select Type"
      />

      {isTravel && (
        <TravelRoutingEditor
          draft={draft}
          setDraft={setDraft}
          activityTypes={activityTypes}
          categoryId={draft.category_id}
          fallbackDate={date}
          onTypeCreated={refetchTypes}
        />
      )}

      {!draft.use_legs && (
        <div className="tp-field">
          <span className="tp-label">End Date</span>
          <input
            type="date"
            min={String(date).slice(0, 10)}
            value={endDateValue}
            onClick={openNativePicker}
            onChange={e => {
              const v = String(e.target.value || '').slice(0, 10);
              if (v && v < String(date).slice(0, 10)) return;
              setDraft(prev => ({ ...prev, end_date: v }));
            }}
          />
        </div>
      )}

      <div className="tp-field">
        <span className="tp-label">Description</span>
        <textarea
          rows={4}
          placeholder="Description (Markdown: **bold**, *italic*, lists, links)"
          value={draft.description || ''}
          onChange={e => setDraft(prev => ({ ...prev, description: e.target.value }))}
          style={{ resize: 'vertical', minHeight: 80 }}
        />
      </div>

      <div className="tp-field">
        <span className="tp-label">Location (optional)</span>
        <AddressSuggestInput
          value={draft.location_address || ''}
          onChange={(v) => setDraft(prev => ({
            ...prev,
            location_address: v,
            location_lat: null,
            location_lon: null,
            location_city: '',
          }))}
          onSelect={(s) => setDraft(prev => ({
            ...prev,
            location_address: s.display_name || s.label || '',
            location_lat: Number(s.lat) || null,
            location_lon: Number(s.lon) || null,
            location_city: cityKeyFromText(s.label || s.display_name) || '',
          }))}
          placeholder="Add a location for this activity"
        />
      </div>

      <div className="tp-field">
        <span className="tp-label">Booking link (optional)</span>
        <input
          type="url"
          placeholder="https://… (GetYourGuide, Viator, ticket, etc.)"
          value={draft.booking_url || ''}
          onChange={e => setDraft(prev => ({ ...prev, booking_url: e.target.value }))}
        />
      </div>

      <div className="tp-field">
        <span className="tp-label">Confirmation / reference (optional)</span>
        <input
          type="text"
          placeholder="Voucher or confirmation number"
          value={draft.booking_ref || ''}
          onChange={e => setDraft(prev => ({ ...prev, booking_ref: e.target.value }))}
        />
      </div>

      <div className="tp-grid" style={{ gap: 10 }}>
        <div className="tp-col-6">
          <div className="tp-field">
            <span className="tp-label">Start</span>
            <input
              type="time"
              step="60"
              value={draft.start_time || ''}
              onClick={openNativePicker}
              onChange={e => setDraft(prev => ({ ...prev, start_time: e.target.value }))}
            />
          </div>
        </div>
        <div className="tp-col-6">
          <div className="tp-field">
            <span className="tp-label">End</span>
            <input
              type="time"
              step="60"
              value={draft.end_time || ''}
              onClick={openNativePicker}
              onChange={e => setDraft(prev => ({ ...prev, end_time: e.target.value }))}
            />
          </div>
        </div>
      </div>

      <div
        className="tp-row"
        style={{
          justifyContent: 'flex-end',
          gap: 8,
          marginTop: 4,
          position: 'sticky',
          bottom: 0,
          background: 'var(--tp-bg)',
          paddingTop: 10,
          paddingBottom: 10,
          zIndex: 1,
        }}
      >
        <button type="button" onClick={onSubmit}>
          {isEditing ? 'Save' : 'Add'}
        </button>
        <button type="button" className="tp-btn--ghost" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}
